/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export enum SettingsViewType {
  CREATION = 'CREATION',
  UPDATE = 'UPDATE',
  PREVIEW = 'PREVIEW',
  DELETE = 'DELETE',
};

export enum SettingsViewPermissionsType {
  TABLE = 'TABLES',
  LIST = 'LIST',
};

export enum StepSettingsType {
  CONFIG_SETTINGS = 'CONFIG_SETTINGS',
  PROCESSING_SETTINGS = 'PROCESSING_SETTINGS',
  COMPLETE_SETTINGS = 'COMPLETE_SETTINGS',
  ERROR_SETTINGS = 'ERROR_SETTINGS',
};

export enum StepStatusType {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
};

export enum CrudsType {
  CREATE = 'create',
  DELETE = 'delete',
  EDIT = 'update',
  VIEW = 'view'
};

export enum TypeUpdateOptions {
  REPLACE = 'REPLACE',
  REMOVE = 'REMOVE',
  APPEND = 'APPEND',
};